var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { postJson, putJson, withDone, withValidate } from '@rad/utility/http';
const map = (_a) => {
    var { identifier } = _a, rest = __rest(_a, ["identifier"]);
    return (Object.assign({ identifierType: identifier.type, identifier: identifier.value }, rest));
};
export const sendLoginOTP = (x) => withDone(withValidate(postJson('/api/auth/send-otp', map(x))))();
export const confirmLoginOTP = (x) => withDone(withValidate(postJson('/api/auth/confirm-otp', map(x))))();
export const sendCreateOTP = (x) => withDone(withValidate(postJson('/api/auth/send-update-otp', map(x))))();
export const confirmCreateOTP = (x) => withDone(withValidate(postJson('/api/auth/confirm-update-otp', map(x))))();
export const sendUpdateOTP = (x) => withDone(withValidate(putJson('/api/auth/send-update-otp', map(x))))();
export const confirmUpdateOTP = (x) => withDone(withValidate(putJson('/api/auth/confirm-update-otp', map(x))))();
export const refreshToken = () => withDone(withValidate(postJson('/api/auth/refresh', {})))();
export const logoutUser = () => withDone(postJson('/api/auth/logout', {}))();
